import * as Yup from "yup";

export const reportMacroFormValidation = Yup.object().shape({
  shortname: Yup.string()
    .nullable()
    .required("Shortname is required")
    .trim()
    .matches(/^[a-zA-Z0-9_\-]+$/, "Shortname can only contain letters, numbers, underscores, and hyphens"),
  expandedText: Yup.string().nullable().required("Expanded text is required"),
});
